import { render } from "./Pedestal.vue?vue&type=template&id=d71ebc70&scoped=true"
import script from "./Pedestal.vue?vue&type=script&lang=js"
export * from "./Pedestal.vue?vue&type=script&lang=js"

import "./Pedestal.vue?vue&type=style&index=0&id=d71ebc70&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d71ebc70"]])

export default __exports__